module.exports = __webpack_public_path__ + "static/img/img12.ea7f80a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img12.jpg
// module id = OfBI
// module chunks = 1